import React from 'react';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import 'theme/pdf.css';

interface PdfLayoutProps {
  children?: React.ReactNode;
}

const theme = createTheme({
  palette: {},
  spacing: (factor) => `${0.35 * factor}rem`,
  typography: {
    fontFamily: ['Calibri', 'Arial', 'sans-serif'].join(','),
    fontSize: 9,
    body2: {},
    body1: {},

    h1: {
      fontSize: '2rem',
    },
    subtitle1: {
      fontSize: '1.2rem',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        header: {},
        main: {
          margin: '1cm',
          marginTop: '0.5cm',
        },
        footer: {
          position: 'fixed',
          bottom: 0,
          marginLeft: '1cm',
        },
      },
    },
  },
});

const PdfLayout: React.FC<PdfLayoutProps> = (props) => {
  const { children } = props;
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export { PdfLayout };
